<template>
  <div style="line-height: 30px; padding: 20px">
    签到系统<br>
    1.每日签到获得10积分，
    连续签到10天可额外获得50积分<br>
    2.店员收到打赏单/指定单可获得积分，1rmb=1积分<br>
    3.响应随机单即可获得5积分<br>
    4.邀请店员成功注册或客户关注并消费，可获得50积分 (用户首次关注消费
    与打赏不冲突，店员可获得50积分+对应消费金额的积分)<br>
    5.订单超时未接扣除积分，一次50积分，积分不够的情况下可以负数，负数
    积分店员自动冻结提现功能，积分转正自动恢复<br>
    6.店员等级重置，根据积分升/降级<br>
  </div>
</template>

<script>
export default {
  name: "signInRule"
}
</script>

<style scoped>

</style>